import { defineRecipe } from '@chakra-ui/react';

export default defineRecipe({
  defaultVariants: {
    variant: 'shine',
  },
  variants: {
    loading: {
      false: {
        background: 'unset !important',
        backgroundColor: 'unset !important',
        backgroundImage: 'unset !important',
        animation: 'unset !important',
      },
    },
    variant: {
      shine: {
        '--start-color': '#f0f4fa',
        '--end-color': '#e1e7ed',
        _dark: {
          '--start-color': '#24384f',
          '--end-color': '#304961',
        },
      },
    },
  },
});
